import React, { useState } from "react";
import { Grid, Box, AppBar, Tab, Tabs } from "@mui/material";
import Header from "../Header/Header";
import { CustomerDTO, SiteDTO } from "@beable/roster-backend-client-v1";
import BasePanel from "../Common/Layout/BasePanel";
import { BasePanelBox } from "../Common/Layout/BasePanelBox";
import BaseSheet from "../Common/Layout/BaseSheet";
import { StyledPanelHeader } from "../Common/Layout/PanelHeader";
import CustomerSelector from "../Common/CustomerSelector";
import SiteSelector from "../Common/SiteSelector";
import EnrollmentsTransform from "./EnrollmentsTransform";
import UsersTransform from "./UsersTransform";
import RoleTransform from "./RoleTransform";


interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

function tabProps(index: any) {
    return {
        id: `transform-tab-${index}`,
        "aria-controls": `transform-tabpanel-${index}`,
    };
}
export default function Transform() {
    const [value, setValue] = React.useState(0);
    const [customer, setCustomer] = useState<CustomerDTO>();
    const [site, setSite] = useState<SiteDTO>();
    const [isSiteSelected, setIsSiteSelected] = useState<boolean>(false);

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleCustomerChange = (customer: CustomerDTO | undefined) => {
        setCustomer(customer);
        handleSiteChange(undefined);
    }

    const handleSiteChange = async (site: SiteDTO | undefined) => {
        setSite(site);
        setIsSiteSelected(!!site);
    }
    return (
        <>
            <Header />
            <Grid container>
                <BasePanel>
                    <BasePanel>
                        <BasePanelBox>
                            <StyledPanelHeader header="Transform" />
                            <Grid container size={12}>
                                <CustomerSelector
                                    onSelect={handleCustomerChange}
                                    variant='outlined'
                                />
                                <SiteSelector
                                    customerId={customer?.id ?? ''}
                                    onSelect={handleSiteChange}
                                    disabled={!customer}
                                    variant='outlined'
                                />
                            </Grid>
                        </BasePanelBox>
                    </BasePanel>
                </BasePanel>
                <BaseSheet>
                    <AppBar position="static">
                        <Tabs
                            value={value}
                            onChange={handleChangeTabs}
                            aria-label="TransformTabs"
                            textColor='inherit'
                            indicatorColor='secondary'
                        >
                            <Tab label="Transform Users" {...tabProps(0)} />
                            <Tab label="Transform Enrollments" {...tabProps(1)} />
                            <Tab label="Transform Roles" {...tabProps(2)} />
                        </Tabs>
                    </AppBar>
                    <TabPanel value={value} index={0}>
                        <UsersTransform
                            site={site}
                            isSiteSelected={isSiteSelected}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <EnrollmentsTransform
                            site={site}
                            isSiteSelected={isSiteSelected}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <RoleTransform
                            site={site}
                            isSiteSelected={isSiteSelected}
                        />
                    </TabPanel>
                </BaseSheet>
            </Grid>
        </>
    );
}
